import React, { Component } from "react";
import { connect } from "react-redux";

import {
  Wrapper,
  Container,
  KeyboardView,
  Copy,
  Bold
} from "app/NativeComponents/common";
import {
  NewHeader,
  GhostButton,
  InlineButton,
  BottomNavBar,
  AttentionBox
} from "app/NativeComponents/snippets";

import { popSidePanel, openUrl, displayIntercom } from "app/NativeActions";

import IAPPaywall from "app/NativeComponents/components/IAPPaywall";

import {
  getNewDealMachineUpgradeUrl,
  getNewDealMachineUpgradeGuideUrl
} from "../newDealMachineUpgrade";

/*
  Classic doesn't sell upgrades anymore -- this panel used to render a Contentful
  driven Stripe upsell, and rendered completely blank whenever the Contentful entry
  or the feature_metadata row behind it was missing (BYE-126). It now always renders
  a heading, the caller's context, and a CTA into the new DealMachine.
*/
class UnlockFeatureModal extends Component {
  constructor(props) {
    super(props);

    const panel_data =
      props.device == "mobile"
        ? props?.route?.params?.panel_data
        : props.panel_data;

    this.state = {
      panel_data,
      feature_upsell_info: panel_data?.feature_upsell_info,
      description: !!panel_data?.description ? panel_data.description : null,
      renderContent: panel_data?.renderContent
        ? panel_data.renderContent
        : null,
      //callers that were mid-action (like List Builder) say what didn't happen when this panel is closed
      cancel_notice: !!panel_data?.cancel_notice
        ? panel_data.cancel_notice
        : "Nothing was changed on your account.",
      iap: panel_data?.iap,
      upsell_adapty_slug: panel_data?.upsell_adapty_slug
    };

    this.handleBack = this.handleBack.bind(this);
  }

  handleBack() {
    this.props.popSidePanel();
  }

  render() {
    const {
      feature_upsell_info,
      description,
      renderContent,
      cancel_notice,
      iap,
      upsell_adapty_slug
    } = this.state;

    //in app purchase accounts can't be sent to a browser checkout
    if (iap) {
      return <IAPPaywall upsell_adapty_slug={upsell_adapty_slug} />;
    }

    const feature_slug =
      feature_upsell_info?.slug || this.state.panel_data?.event_slug;
    const has_context = !!renderContent || !!description;

    return (
      <Container>
        <NewHeader
          title="Upgrade in the new DealMachine"
          subtitle="Plan changes have moved"
          leftButton={{
            icon: "arrow-back",
            onPress: () => {
              this.handleBack();
            }
          }}
        />

        <KeyboardView style={{ flex: 1 }}>
          {renderContent ? (
            renderContent()
          ) : !!description ? (
            <Wrapper style={{ padding: 25 }}>
              <Copy>{description}</Copy>
            </Wrapper>
          ) : null}

          <Wrapper
            style={{
              padding: 25,
              paddingTop: has_context ? 0 : 25
            }}
          >
            <Copy>
              <Bold>
                DealMachine Classic no longer handles plan changes or upgrades.
              </Bold>
            </Copy>
            <Copy style={{ paddingTop: 10 }}>
              Log in to the new DealMachine to choose the plan you need.
            </Copy>
          </Wrapper>

          <AttentionBox
            style={{ marginLeft: 25, marginRight: 25 }}
            icon="info"
            description={cancel_notice}
          />
        </KeyboardView>

        <BottomNavBar>
          <GhostButton
            primary={true}
            button_type="full"
            marketing_slug="classic_upsell_panel_upgrade_in_new_dealmachine"
            onPress={() => {
              openUrl(getNewDealMachineUpgradeUrl(feature_slug));
            }}
          >
            Upgrade in the New DealMachine
          </GhostButton>

          <InlineButton
            button_type="full"
            marketing_slug="classic_upsell_panel_migration_guide"
            onPress={() => {
              openUrl(getNewDealMachineUpgradeGuideUrl(feature_slug));
            }}
          >
            How moving to the new DealMachine works
          </InlineButton>

          <InlineButton
            button_type="full"
            id={"intercom_button"}
            onPress={() => {
              displayIntercom();
            }}
          >
            Talk To Support
          </InlineButton>
        </BottomNavBar>
      </Container>
    );
  }
}

const mapStateToProps = ({ auth, native, settings, billing }) => {
  const { token, user } = auth;
  const { device, platform, desktopMobile } = native;
  const { colors } = settings;
  const { source_of_truth } = billing;

  return {
    token,
    user,
    device,
    platform,
    colors,
    source_of_truth,
    desktopMobile
  };
};

export default connect(mapStateToProps, {
  popSidePanel
})(UnlockFeatureModal);
